import { useTheme } from "../../context/ThemeContext";

export function PromiseMeter({ pct, color }) {
  return (
    <div className="flex items-center gap-2">
      <div className="flex-1 h-1.5 border border-black bg-gray-200">
        <div style={{ width: `${pct}%`, backgroundColor: color }} className="h-full" />
      </div>
      <span className="text-xs font-black" style={{ color }}>{pct}%</span>
    </div>
  );
}

export function CivicScore({ score }) {
  const { isDark } = useTheme();
  const text = isDark ? "#F8FAFC" : "#0F172A";
  const textSec = isDark ? "#94A3B8" : "#475569";
  const surface = isDark ? "#1E293B" : "#FFFFFF";
  return (
    <div className="border-2 border-black p-4" style={{ backgroundColor: surface, boxShadow: "3px 3px 0 #000" }}>
      <p className="text-xs font-black mb-2" style={{ color: textSec }}>CIVIC READINESS SCORE</p>
      <div className="flex items-baseline gap-1 mb-2">
        <span className="text-4xl font-black" style={{ color: score >= 7 ? "#10B981" : score >= 4 ? "#F59E0B" : "#EF4444", fontFamily: "Outfit, sans-serif" }}>{score}</span>
        <span className="text-lg font-black" style={{ color: textSec }}>/10</span>
      </div>
      <div className="flex gap-1 mb-1">
        {Array.from({ length: 10 }).map((_, i) => (
          <div key={i} className="flex-1 h-2 border border-black" style={{ backgroundColor: i < score ? "#FFC82E" : (isDark ? "#334155" : "#E2E8F0") }} />
        ))}
      </div>
      <p className="text-xs" style={{ color: textSec }}>
        {score >= 8 ? "Election-ready!" : score >= 5 ? "Getting there — keep going" : "Start with your postcode below"}
      </p>
    </div>
  );
}
